import { formatAmount } from '@arabat/i18n';
import { useTranslation } from 'react-i18next';

/** `formatAmount` in the UI language, for screens that show many amounts (display only). */
export function useMoneyFormat() {
  const { i18n } = useTranslation();
  return (value: Parameters<typeof formatAmount>[0]) => formatAmount(value, i18n.language);
}
